import { createSlice, Draft, PayloadAction } from '@reduxjs/toolkit';
import { startOfMonth, subMonths } from "date-fns";
import moment from "moment";

import { stateDate } from "../../../../utils/formatDate";

const initialState: any = {
	limit: JSON.parse(localStorage.getItem('pageLimit') as string) || 10,
	data: null,
	pages: 1,
	page: 1,
	applicationData: {
		firstName: '',
		lastName: '',
		gender: 'Male',
	},
	vacancyListInputValues: {
		cities: null,
		area: [],
		project: null,
		regions: [],
		status: null,
		supervisors: [],
		type: null,
	},
	modifiedDate: {
		formattedDateFrom: moment(
			stateDate(startOfMonth(subMonths(new Date(), 1)))
		).format("DD/MM/YYYY"),
		formattedDateTo: moment(stateDate(new Date())).format("DD/MM/YYYY"),
	},
	createDate: {
		formattedDateFrom: moment(
			stateDate(startOfMonth(subMonths(new Date(), 1)))
		).format("DD/MM/YYYY"),
		formattedDateTo: moment(stateDate(new Date())).format("DD/MM/YYYY"),
	},
	employeesListSettings: JSON.parse(
		localStorage.getItem('selectedEmployeesListTabs') as string
	) || [
			'name',
			'login',
			'role',
			'position',
			'hasroute',
			'freelancer',
			'project',
			'areas',
			'service',
			'vsv',
			'phone',
			'verified'
		],
	isPending: true,
	filters: {
		areas: [],
		projects: [],
		regions: [],
		statuses: [],
		supervisors: [],
		types: [],
		schedules: []
	},
	employeeStatus: null,
	checkboxes: [false, false],
};

export const employeesListSlice = createSlice({
	name: 'employeesList',
	initialState,
	reducers: {
		reducerEmployeesListSettings: (
			state: Draft<any>,
			action: PayloadAction<any>
		) => {
			state.employeesListSettings = action.payload;
		},
		reducerSelectedEmployeesId: (
			state: Draft<any>,
			action: PayloadAction<any>
		) => {
			state.selectedEmployeesId = action.payload;
		},
		reducerEmployeeStatus: (state: Draft<any>, action: PayloadAction<any>) => {
			state.employeeStatus = action.payload;
		},
	},
});

export const {
	reducerEmployeesListSettings,
	reducerEmployeeStatus,
	reducerSelectedEmployeesId,
} = employeesListSlice.actions;

export default employeesListSlice.reducer;
